/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolToolsLadderIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-tools-ladder"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M5.95 21.32Q5.33 21.32 4.94 20.81Q4.55 20.3 4.72 19.7L9.18 3.63Q9.3 3.2 9.65 2.94Q10 2.67 10.43 2.67Q11.07 2.67 11.46 3.19Q11.85 3.7 11.68 4.3L11.28 5.67L16.23 5.67L16.77 3.63Q16.9 3.2 17.26 2.94Q17.63 2.67 18.05 2.67Q18.68 2.67 19.06 3.19Q19.45 3.7 19.27 4.3L14.82 20.38Q14.7 20.8 14.35 21.06Q14 21.32 13.57 21.32Q12.93 21.32 12.54 20.81Q12.15 20.3 12.32 19.7L12.72 18.32L7.78 18.32L7.22 20.38Q7.1 20.8 6.74 21.06Q6.38 21.32 5.95 21.32ZM9.9 10.68L14.82 10.68L15.47 8.32L10.55 8.32ZM8.53 15.68L13.45 15.68L14.1 13.32L9.18 13.32Z" fill={color} />
    </svg>
  );
}
